import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/base.scss";
import "./assets/scss/mixin.scss";
import "./vendors/themify-icons/themify-icons.css";
import "./vendors/js/fontawesome.js";
import "./vendors/css/grid.css";
import "./assets/scss/styles.scss";
import "./assets/scss/space.scss";
import "./assets/scss/text.scss";
import "./assets/scss/brand.scss";
import "./assets/scss/border.scss";
import "./assets/scss/actions.scss";
import "./assets/scss/lineHeight.scss";
import "./assets/scss/background.scss";
import "./assets/scss/position.scss";

import { Provider } from "react-redux";
import store from "./redux/store";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
